// extracted by mini-css-extract-plugin
export default {"wrap":"N-z","heading":"O-z","formError":"P-z"};